import { createSelector } from 'reselect';
import { resources } from 'store/saga/entities/bound';
import { selectActiveVenueId, selectRouteParams } from 'selectors/general';

export const selectResourcesEntity = createSelector(
  state => state || {},
  selectActiveVenueId,
  (state, venueId) => {
    const { data, error, loaded, loading } = resources.select(state, venueId);
    return {
      data: loaded ? data : [],
      error,
      isLoading: loading,
      isLoaded: loaded,
    };
  }
);

export const selectResourcesIsLoading = createSelector(
  state => state || {},
  selectActiveVenueId,
  (state, venueId) => resources.loading(state, venueId)
);

export const selectResources = createSelector(
  state => state || {},
  selectActiveVenueId,
  (state, venueId) => (resources.loaded(state, venueId) ? resources.data(state, venueId) : [])
);

export const selectSelectedResourceId = createSelector(selectRouteParams, params => params.itemId);

export const selectSelectedResource = createSelector(
  selectResources,
  selectSelectedResourceId,
  (res, selectedId) => res.find(({ id }) => id === selectedId) || {}
);

export const selectResourceServices = createSelector(selectResources, selectSelectedResource, (srv, { services }) =>
  srv ? srv.filter(({ id }) => services && services.map(({ id: serviceId }) => serviceId).includes(id)) : []
);
